class ProductDetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.disclosure = this.querySelector('details');

    if (!this.disclosure) return;

    this.addPreviewEllipsis();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  addPreviewEllipsis() {
    const preview = this.querySelector('.main-product__description-preview');
    if (!preview) return;

    const visibleBlocks = Array.from(preview.children).slice(0, 2);
    if (!visibleBlocks.length) return;

    for (let i = 0; i < visibleBlocks.length; i++) {
      if (this.isVisuallyClamped(visibleBlocks[i], preview)) {
        visibleBlocks.slice(i + 1).forEach((laterBlock) => {
          laterBlock.style.display = 'none';
        });
        return;
      }
    }

    const finalBlock = visibleBlocks[visibleBlocks.length - 1];
    let finalTextContainer = finalBlock;
    const textContainers = finalBlock.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6');

    if (finalBlock.matches('ul, ol')) {
      const visibleItems = Array.from(finalBlock.children).slice(0, 2);
      const finalItem = visibleItems[visibleItems.length - 1];
      if (finalItem) {
        finalTextContainer = finalItem.querySelector('p:last-child') || finalItem;
      }
    } else if (textContainers.length) {
      finalTextContainer = textContainers[textContainers.length - 1];
    }

    const ellipsis = document.createElement('span');
    ellipsis.className = 'main-product__description-preview-ellipsis';
    ellipsis.textContent = '\u00a0\u2026';
    finalTextContainer.append(ellipsis);
  }

  isVisuallyClamped(block, preview) {
    if (block.matches('ul, ol')) return false;

    const visibleHeight = block.getBoundingClientRect().height;
    const clone = block.cloneNode(true);

    Object.assign(clone.style, {
      display: 'block',
      height: 'auto',
      maxHeight: 'none',
      overflow: 'visible',
      position: 'absolute',
      visibility: 'hidden',
      webkitBoxOrient: 'initial',
      webkitLineClamp: 'unset',
      width: `${block.getBoundingClientRect().width}px`,
    });

    preview.append(clone);
    const fullHeight = clone.getBoundingClientRect().height;
    clone.remove();

    return fullHeight > visibleHeight + 1;
  }

  handleClick(event) {
    if (event.target.closest('summary')) return;
    if (event.target.closest('a, button, input, select, textarea, label')) return;

    const selection = window.getSelection();
    if (selection && !selection.isCollapsed) return;

    this.disclosure.open = !this.disclosure.open;
  }
}

if (!customElements.get('product-details-disclosure')) {
  customElements.define('product-details-disclosure', ProductDetailsDisclosure);
}
